import {Temp} from "../utils/Temp.js";

const DROP_H_MARGIN = 6;
const INDENT = 18;


export class CategoriesPanel {

	static generateChildrenPanel(children, level = 0, rootElement = null, supportExclusiveClick = false) {
		const panel = Temp.tag("div", { clazz: 'cats-children' });
		panel.attr("data-level", level);
		if (rootElement == null) rootElement = panel;
		for (let ch of children) {
			const el = this.generateCategoryPanel(ch, level, rootElement, supportExclusiveClick);
			panel.append(el);
		}
		return panel;
	}

	/**
	 * Generate jQuery element with categories
	 * @param ch
	 * @param level
	 * @param rootElement
	 * @param {boolean} supportExclusiveClick categories can be selected by "exclusive" click (other cats are unselected in this way)
	 * @return {jQuery} generated element
	 */
	static generateCategoryPanel(ch, level, rootElement, supportExclusiveClick) {
		const el = Temp.tag("div", { clazz: 'cats-cat' });
		el.attr("data-id", ch.id);
		const hasChildren = ch.children && ch.children.length > 0;

		const categoryRow = Temp.tag("div", { clazz: 'cats-cat-row' });
		categoryRow.attr("data-filter", ch.title.toLowerCase());
		let selectable = typeof ch.sel === "undefined" || ch.sel;
		if (!selectable) categoryRow.addClass("cats-unselectable");
		if (level > 0) categoryRow.css("padding-left", (level * INDENT + DROP_H_MARGIN) + "px");

		const label = Temp.tag("label");
		const textSpan = Temp.tag("span");
		textSpan.text(" "+ch.title);
		label.append(textSpan);

		if (ch.icon) {
			label.prepend(Icon.fi(ch.icon));
		}
		if (selectable) {
			const chbox = Temp.checkbox();
			let disabled = typeof ch.dis !== "undefined" && ch.dis;
			if (disabled) {
				chbox.attr("disabled",ch.dis);
				//chbox.attr("readonly",ch.dis);
			}
			chbox.attr("value", ch.id);
			chbox.attr("data-type", typeof ch.id);
			label.prepend(chbox);
			let exclusiveClick = false;
			if (supportExclusiveClick) {
				textSpan.on("mousedown", function() {
					exclusiveClick = true;
				});
				chbox.on("mousedown", function() {
					exclusiveClick = false;
				});
			}
			chbox.on("change", function() {
				const checked = chbox.is(":checked");
				exclusiveClick = exclusiveClick && checked;
				if (exclusiveClick) {
					const root = CategoriesPanel.findRootPanel(chbox);
					if (CategoriesPanel.countSelected(root) > 2) {
						exclusiveClick = false;
					} else {
						CategoriesPanel.clearCheckboxesExcept(root.find("input[type=checkbox]"), ch.id);
					}
				}
				rootElement.trigger("selectionchange", [ ch.id, checked, exclusiveClick]);
			});
		}
		categoryRow.append(label);
		el.append(categoryRow);
		if (hasChildren) {
			el.append(CategoriesPanel.generateChildrenPanel(ch.children, level + 1, rootElement, supportExclusiveClick));
		}
		return el;
	}

	static findRootPanel(child) {
		do {
			if (child.hasClass("cats-children")) {
				if (child.attr("data-level") === "0") return child;
			}
			child = child.parent();
		} while (child);
		return null;
	}

	static countSelected(rootPanel) {
		const allChecked = rootPanel.find("input[type=checkbox]:checked");
		return allChecked.length;
	}

	static clearCheckboxesExcept(checkboxes, id) {
		checkboxes.each(function() {
			const chb = $(this);
			const dataType = chb.attr("data-type");
			let chid = chb.val();
			if (dataType === "number") chid = parseInt(chid);
			if (chid !== id) chb.prop("checked", false);
		});
	}

	static updateCheckboxesFromData(checkboxes, dataArray) {
		checkboxes.each(function() {
			const chb = $(this);
			const dataType = chb.attr("data-type");
			let id = chb.val();
			if (dataType === "number") id = parseInt(id);
			chb.prop("checked", dataArray.includes(id));
		});
	}

	static extractDataFromCheckboxes(checkedBoxes) {
		const d = [];
		checkedBoxes.each(function() {
			const chb = $(this);
			const dataType = chb.attr("data-type");
			let id = chb.val();
			if (dataType === "number") id = parseInt(id);
			d.push(id);
		});
		return d;
	}
}